import { render } from "./DashboardView.vue?vue&type=template&id=61a9f584&ts=true"
import script from "./DashboardView.vue?vue&type=script&lang=ts"
export * from "./DashboardView.vue?vue&type=script&lang=ts"

import "./DashboardView.vue?vue&type=style&index=0&id=61a9f584&lang=scss"

import exportComponent from "/builds/kligmanbb/medsafe-smart-pro/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QList from 'quasar/src/components/item/QList.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QSpinnerHourglass from 'quasar/src/components/spinner/QSpinnerHourglass.js';
import QPullToRefresh from 'quasar/src/components/pull-to-refresh/QPullToRefresh.js';
import QVirtualScroll from 'quasar/src/components/virtual-scroll/QVirtualScroll.js';
import QInfiniteScroll from 'quasar/src/components/infinite-scroll/QInfiniteScroll.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import QSpinnerGears from 'quasar/src/components/spinner/QSpinnerGears.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QSlideItem from 'quasar/src/components/slide-item/QSlideItem.js';
import QField from 'quasar/src/components/field/QField.js';import Ripple from 'quasar/src/directives/Ripple.js';
import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QList,QExpansionItem,QItemSection,QAvatar,QItemLabel,QSkeleton,QBadge,QIcon,QItem,QBtn,QInput,QSelect,QTabs,QTab,QSpinnerHourglass,QPullToRefresh,QVirtualScroll,QInfiniteScroll,QPopupProxy,QBanner,QBtnGroup,QSpinnerGears,QMenu,QSpinnerDots,QDialog,QCard,QCardSection,QCardActions,QSeparator,QCheckbox,QSlideItem,QField});qInstall(script, 'directives', {Ripple,ClosePopup});
